export default "__VITE_ASSET__BfAIJ_cl__"